/**
 * Official Warsaw MSI obszary (143 rejony) — name + parent district. GENERATED
 * from flat.warsaw_msi_rejony (city WFS layer ns92528565:MSI, currency maj 2026)
 * — do not hand-edit; re-run scripts/import-msi-rejony.mjs then regenerate via
 *   select nazwa, dzielnica from flat.warsaw_msi_rejony order by dzielnica, nazwa
 * Source of truth for the search osiedle picker, so picker names == the rejon we
 * label on offers (source_posts.extracted_subdistrict). © m.st. Warszawa.
 */
export interface MsiRejon {
  name: string;
  district: string;
}

export const WARSAW_MSI_REJONY: MsiRejon[] = [
  { name: "Bemowo-Lotnisko", district: "Bemowo" },
  { name: "Boernerowo", district: "Bemowo" },
  { name: "Chrzanów", district: "Bemowo" },
  { name: "Fort Bema", district: "Bemowo" },
  { name: "Fort Radiowo", district: "Bemowo" },
  { name: "Górce", district: "Bemowo" },
  { name: "Groty", district: "Bemowo" },
  { name: "Jelonki Północne", district: "Bemowo" },
  { name: "Jelonki Południowe", district: "Bemowo" },
  { name: "Lotnisko", district: "Bemowo" },
  { name: "Białołęka Dworska", district: "Białołęka" },
  { name: "Brzeziny", district: "Białołęka" },
  { name: "Choszczówka", district: "Białołęka" },
  { name: "Dąbrówka Szlachecka", district: "Białołęka" },
  { name: "Grodzisk", district: "Białołęka" },
  { name: "Henryków", district: "Białołęka" },
  { name: "Kobiałka", district: "Białołęka" },
  { name: "Nowodwory", district: "Białołęka" },
  { name: "Szamocin", district: "Białołęka" },
  { name: "Tarchomin", district: "Białołęka" },
  { name: "Żerań", district: "Białołęka" },
  { name: "Chomiczówka", district: "Bielany" },
  { name: "Huta", district: "Bielany" },
  { name: "Las Bielański", district: "Bielany" },
  { name: "Marymont-Kaskada", district: "Bielany" },
  { name: "Marymont-Ruda", district: "Bielany" },
  { name: "Młociny", district: "Bielany" },
  { name: "Piaski", district: "Bielany" },
  { name: "Placówka", district: "Bielany" },
  { name: "Radiowo", district: "Bielany" },
  { name: "Słodowiec", district: "Bielany" },
  { name: "Stare Bielany", district: "Bielany" },
  { name: "Wawrzyszew", district: "Bielany" },
  { name: "Wólka Węglowa", district: "Bielany" },
  { name: "Wrzeciono", district: "Bielany" },
  { name: "Augustówka", district: "Mokotów" },
  { name: "Czerniaków", district: "Mokotów" },
  { name: "Ksawerów", district: "Mokotów" },
  { name: "Sadyba", district: "Mokotów" },
  { name: "Siekierki", district: "Mokotów" },
  { name: "Sielce", district: "Mokotów" },
  { name: "Służew", district: "Mokotów" },
  { name: "Służewiec", district: "Mokotów" },
  { name: "Stary Mokotów", district: "Mokotów" },
  { name: "Stegny", district: "Mokotów" },
  { name: "Wierzbno", district: "Mokotów" },
  { name: "Wyględów", district: "Mokotów" },
  { name: "Filtry", district: "Ochota" },
  { name: "Rakowiec", district: "Ochota" },
  { name: "Stara Ochota", district: "Ochota" },
  { name: "Szczęśliwice", district: "Ochota" },
  { name: "Nowa Praga", district: "Praga-Północ" },
  { name: "Pelcowizna", district: "Praga-Północ" },
  { name: "Stara Praga", district: "Praga-Północ" },
  { name: "Szmulowizna", district: "Praga-Północ" },
  { name: "Gocław", district: "Praga-Południe" },
  { name: "Gocławek", district: "Praga-Południe" },
  { name: "Grochów", district: "Praga-Południe" },
  { name: "Kamionek", district: "Praga-Południe" },
  { name: "Olszynka Grochowska", district: "Praga-Południe" },
  { name: "Saska Kępa", district: "Praga-Południe" },
  { name: "Kawęczyn-Wygoda", district: "Rembertów" },
  { name: "Nowy Rembertów", district: "Rembertów" },
  { name: "Stary Rembertów", district: "Rembertów" },
  { name: "Muranów", district: "Śródmieście" },
  { name: "Nowe Miasto", district: "Śródmieście" },
  { name: "Powiśle", district: "Śródmieście" },
  { name: "Solec", district: "Śródmieście" },
  { name: "Śródmieście Północne", district: "Śródmieście" },
  { name: "Śródmieście Południowe", district: "Śródmieście" },
  { name: "Stare Miasto", district: "Śródmieście" },
  { name: "Ujazdów", district: "Śródmieście" },
  { name: "Bródno", district: "Targówek" },
  { name: "Bródno-Podgrodzie", district: "Targówek" },
  { name: "Elsnerów", district: "Targówek" },
  { name: "Targówek Fabryczny", district: "Targówek" },
  { name: "Targówek Mieszkaniowy", district: "Targówek" },
  { name: "Utrata", district: "Targówek" },
  { name: "Zacisze", district: "Targówek" },
  { name: "Czechowice", district: "Ursus" },
  { name: "Gołąbki", district: "Ursus" },
  { name: "Niedźwiadek", district: "Ursus" },
  { name: "Skorosze", district: "Ursus" },
  { name: "Szamoty", district: "Ursus" },
  { name: "Dąbrówka", district: "Ursynów" },
  { name: "Grabów", district: "Ursynów" },
  { name: "Jeziorki Północne", district: "Ursynów" },
  { name: "Jeziorki Południowe", district: "Ursynów" },
  { name: "Kabaty", district: "Ursynów" },
  { name: "Natolin", district: "Ursynów" },
  { name: "Pyry", district: "Ursynów" },
  { name: "Skarpa Powsińska", district: "Ursynów" },
  { name: "Stary Imielin", district: "Ursynów" },
  { name: "Stary Służew", district: "Ursynów" },
  { name: "Teren wydzielony rezerwat \"Las Kabacki\"", district: "Ursynów" },
  { name: "Ursynów Północny", district: "Ursynów" },
  { name: "Ursynów-Centrum", district: "Ursynów" },
  { name: "Wyczółki", district: "Ursynów" },
  { name: "Aleksandrów", district: "Wawer" },
  { name: "Anin", district: "Wawer" },
  { name: "Falenica", district: "Wawer" },
  { name: "Las", district: "Wawer" },
  { name: "Marysin Wawerski", district: "Wawer" },
  { name: "Miedzeszyn", district: "Wawer" },
  { name: "Międzylesie", district: "Wawer" },
  { name: "Nadwiśle", district: "Wawer" },
  { name: "Radość", district: "Wawer" },
  { name: "Sadul", district: "Wawer" },
  { name: "Wawer", district: "Wawer" },
  { name: "Zerzeń", district: "Wawer" },
  { name: "Groszówka", district: "Wesoła" },
  { name: "Plac Wojska Polskiego", district: "Wesoła" },
  { name: "Stara Miłosna", district: "Wesoła" },
  { name: "Wesoła-Centrum", district: "Wesoła" },
  { name: "Wola Grzybowska", district: "Wesoła" },
  { name: "Zielona-Grzybowa", district: "Wesoła" },
  { name: "Błonia Wilanowskie", district: "Wilanów" },
  { name: "Kępa Zawadowska", district: "Wilanów" },
  { name: "Powsin", district: "Wilanów" },
  { name: "Powsinek", district: "Wilanów" },
  { name: "Wilanów Królewski", district: "Wilanów" },
  { name: "Wilanów Niski", district: "Wilanów" },
  { name: "Wilanów Wysoki", district: "Wilanów" },
  { name: "Zawady", district: "Wilanów" },
  { name: "Nowe Włochy", district: "Włochy" },
  { name: "Okęcie", district: "Włochy" },
  { name: "Opacz Wielka", district: "Włochy" },
  { name: "Paluch", district: "Włochy" },
  { name: "Raków", district: "Włochy" },
  { name: "Salomea", district: "Włochy" },
  { name: "Stare Włochy", district: "Włochy" },
  { name: "Załuski", district: "Włochy" },
  { name: "Czyste", district: "Wola" },
  { name: "Koło", district: "Wola" },
  { name: "Mirów", district: "Wola" },
  { name: "Młynów", district: "Wola" },
  { name: "Nowolipki", district: "Wola" },
  { name: "Odolany", district: "Wola" },
  { name: "Powązki", district: "Wola" },
  { name: "Ulrychów", district: "Wola" },
  { name: "Marymont-Potok", district: "Żoliborz" },
  { name: "Sady Żoliborskie", district: "Żoliborz" },
  { name: "Stary Żoliborz", district: "Żoliborz" },
];
